import { createUseStyles } from 'react-jss';

const KNOB_MARGIN = 3;
const KNOB_WIDTH = 16;
const KNOB_HEIGHT = 16;

export default createUseStyles(
  {
    root: {
      display: 'inline-block',
    },
    container: {
      border: '1px solid #bcc0d1',
      borderRadius: '16px',
      cursor: 'pointer',
      width: 42,
    },
    containerOn: {
      borderColor: 'var(--x-accent-1-1)',
    },
    invisible: {
      display: 'none',
    },
    knob: {
      borderRadius: '50%',
      backgroundColor: '#535771',
      height: KNOB_HEIGHT,
      margin: KNOB_MARGIN,
      width: KNOB_WIDTH,
      transition: 'margin 400ms',
    },
    knobOn: {
      backgroundColor: 'var(--x-accent-1-1)',
      marginLeft: `calc(100% - ${KNOB_MARGIN}px - ${KNOB_WIDTH}px)`,
    },
  },
  { name: 'ToggleSwitch' },
);
